export default {"src":"https://static.spiritory.com/_next/static/media/1.16257895.svg","height":186,"width":96,"blurWidth":0,"blurHeight":0};